module.exports = __webpack_public_path__ + "img/dm.364c9640.svg";